export const ProductLevel = {
  FREE: 'FREE',
  DEPRECATED: 'DEPRECATED',
  STARTER: 'STARTER',
  BASIC: 'BASIC',
  PROFESSIONAL: 'PROFESSIONAL',
  ENTERPRISE: 'ENTERPRISE'
};
export default ProductLevel;